import { TOGGLE_NAVIGATION } from 'redux/types'

const toggleNavigation = (payload) => {
  return { type: TOGGLE_NAVIGATION, payload }
}

export {
  toggleNavigation
}
